var _path, _path2, _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWatchActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 42,
    viewBox: "0 0 91 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 41.5H90.5V41V25C90.5 11.469 79.531 0.5 66 0.5H21C9.67816 0.5 0.5 9.67816 0.5 21C0.5 32.3218 9.67816 41.5 21 41.5H90Z",
    fill: "url(#paint0_linear_1494_502)",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.486 28L43.44 14.998H44.826L46.476 26.086L48.478 14.998H49.6L51.558 26.064L53.23 14.998H54.638L52.57 28H50.986L49.05 18.122L47.114 28H45.486ZM57.9409 28.154C57.6036 28.154 57.2589 28.1027 56.9069 28C56.5696 27.912 56.2763 27.6993 56.0269 27.362C55.7923 27.01 55.6749 26.4673 55.6749 25.734V24.678C55.6749 23.9447 55.8949 23.358 56.3349 22.918C56.7896 22.4633 57.4056 22.06 58.1829 21.708C58.6816 21.4587 59.0849 21.2387 59.3929 21.048C59.7156 20.8573 59.9576 20.6447 60.1189 20.41C60.2803 20.1753 60.3609 19.86 60.3609 19.464V19.002C60.3609 18.65 60.2876 18.3787 60.1409 18.188C59.9943 17.9973 59.7963 17.8653 59.5469 17.792C59.3123 17.7187 59.0629 17.682 58.7989 17.682C58.1389 17.682 57.7063 17.8653 57.5009 18.232C57.2956 18.584 57.1929 19.112 57.1929 19.816V20.74H55.9389V19.684C55.9389 19.1413 56.0123 18.6647 56.1589 18.254C56.3056 17.8287 56.5843 17.4987 56.9949 17.264C57.4056 17.0147 58.0069 16.89 58.7989 16.89C59.6349 16.89 60.2583 16.9853 60.6689 17.176C61.0943 17.3667 61.3729 17.638 61.5049 17.99C61.6516 18.342 61.7249 18.76 61.7249 19.244V28H60.3829L60.3609 26.636C60.1849 27.1347 59.8696 27.516 59.4149 27.78C58.9603 28.0293 58.4689 28.154 57.9409 28.154ZM58.4469 27.23C59.1069 27.23 59.5836 26.9953 59.8769 26.526C60.1849 26.0567 60.3389 25.4333 60.3389 24.656V21.18C60.1923 21.4147 59.9503 21.6273 59.6129 21.818C59.2756 22.0087 58.9309 22.1993 58.5789 22.39C58.0803 22.6833 57.6916 22.9913 57.4129 23.314C57.1489 23.622 57.0169 24.0547 57.0169 24.612V25.47C57.0169 25.998 57.0903 26.3867 57.2369 26.636C57.3836 26.8853 57.5669 27.0467 57.7869 27.12C58.0069 27.1933 58.2269 27.23 58.4469 27.23ZM66.2212 28.022C65.8985 28.022 65.6052 27.9853 65.3412 27.912C65.0772 27.8387 64.8498 27.7213 64.6592 27.56C64.4685 27.384 64.3218 27.164 64.2192 26.9C64.1165 26.6213 64.0652 26.2767 64.0652 25.866V17.968H63.0972V17.264L64.1532 17.11L64.3952 15.064H65.4292V17.11H67.7832V17.968H65.4292V25.624C65.4292 26.0347 65.5025 26.3793 65.6492 26.658C65.7958 26.9367 66.1185 27.076 66.6172 27.076C66.8225 27.076 67.0425 27.0687 67.2772 27.054C67.5118 27.0247 67.6805 27.01 67.7832 27.01V27.89C67.6658 27.89 67.4605 27.912 67.1672 27.956C66.8738 28 66.5585 28.022 66.2212 28.022ZM71.9678 28.198C71.2491 28.198 70.6625 28.1173 70.2078 27.956C69.7531 27.78 69.4231 27.472 69.2178 27.032C69.0125 26.5773 68.9098 25.9173 68.9098 25.052V19.684C68.9098 18.6133 69.1371 17.8873 69.5918 17.506C70.0611 17.11 70.8311 16.912 71.9018 16.912C72.9431 16.912 73.6911 17.1027 74.1458 17.484C74.6151 17.8653 74.8498 18.5693 74.8498 19.596V21.026H73.4858V19.552C73.4858 18.9213 73.3831 18.4667 73.1778 18.188C72.9725 17.8947 72.5471 17.748 71.9018 17.748C71.2565 17.748 70.8238 17.8947 70.6038 18.188C70.3838 18.4667 70.2738 18.9213 70.2738 19.552V25.404C70.2738 26.108 70.3838 26.6067 70.6038 26.9C70.8238 27.1787 71.2711 27.318 71.9458 27.318C72.5618 27.318 72.9725 27.1787 73.1778 26.9C73.3831 26.6213 73.4858 26.1227 73.4858 25.404V23.93H74.8498V25.052C74.8498 25.888 74.7471 26.5333 74.5418 26.988C74.3365 27.4427 74.0211 27.758 73.5958 27.934C73.1705 28.11 72.6278 28.198 71.9678 28.198ZM76.8008 28V14.14H78.0988V18.012C78.2748 17.6747 78.5388 17.4107 78.8908 17.22C79.2428 17.0147 79.6901 16.912 80.2328 16.912C81.0101 16.912 81.5748 17.0513 81.9268 17.33C82.2934 17.594 82.5281 17.946 82.6308 18.386C82.7334 18.8113 82.7848 19.2807 82.7848 19.794V28H81.4208V19.992C81.4208 19.772 81.4134 19.5447 81.3988 19.31C81.3841 19.0607 81.3254 18.8333 81.2228 18.628C81.1348 18.4227 80.9808 18.254 80.7608 18.122C80.5408 17.9753 80.2181 17.902 79.7928 17.902C79.4114 17.902 79.0961 17.968 78.8468 18.1C78.6121 18.2173 78.4361 18.3567 78.3188 18.518C78.2161 18.6793 78.1648 18.8187 78.1648 18.936V28H76.8008Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 18,
    fill: "url(#paint1_linear_1494_502)",
    stroke: "white",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1494_502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.23 21.3695L15.73 15.2695V27.7695",
    stroke: "white",
    strokeWidth: 1.46,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.73 27.8703L16.03 27.6703L17.03 27.0703",
    stroke: "white",
    strokeWidth: 1.46,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.73 25.3687L23.73 22.9688",
    stroke: "white",
    strokeWidth: 1.46,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "3.16 3.16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1299 22.0699L25.8299 21.6699L26.2799 21.4199",
    stroke: "white",
    strokeWidth: 1.46,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1494_502",
    x1: 24.5,
    y1: 11,
    x2: 85,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#147BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0C5EB8",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0037B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1494_502",
    x1: 6.5,
    y1: 10.5,
    x2: 27,
    y2: 36.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#0D78C5",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023AA8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1494_502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.01,
    height: 14.6,
    fill: "white",
    transform: "translate(15 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchActive);
export default __webpack_public_path__ + "static/media/WatchActive.32d13b813383daf36f4dc3b0c07464e1.svg";
export { ForwardRef as ReactComponent };